import { IncidentModel } from './incident.model';
export class CommonAamvaModel extends IncidentModel {
    public cdlHolderIndicator = false;
    public commercialMotorVehicleIndicator = false;
    public hazardousMaterialIndicator = false;
    public passengerIndicator = false;
    public driverLicenseNumber: string;
    public driverLicenseJurisdictionId: number;
}
